import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';

export const TableSkeletonLoader = ({ rows = 5, columns = 6 }) => {
  return (
    <div className="table-responsive fade-in-content">
      <table className="table table-nowrap align-middle mb-0">
        <thead>
          <tr>
            {Array.from({ length: columns }).map((_, idx) => (
              <th key={`th_skel_${idx}`} style={{ padding: '14px 16px' }}>
                <div className="shimmer-box shimmer-text" style={{ width: `${Math.max(40, 85 - idx * 10)}%`, height: '12px', marginBottom: 0 }} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIdx) => (
            <tr key={`tr_skel_${rowIdx}`}>
              {Array.from({ length: columns }).map((_, colIdx) => (
                <td key={`td_skel_${rowIdx}_${colIdx}`} style={{ padding: '14px 16px' }}>
                  <div
                    className="shimmer-box shimmer-text"
                    style={{
                      width: colIdx === 0 ? '24px' : `${Math.max(35, 70 - ((rowIdx + colIdx) % 3) * 15)}%`,
                      height: '14px',
                      marginBottom: 0
                    }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const CardSkeletonLoader = ({ count = 4, sm = 3 }) => {
  return (
    <Row className="fade-in-content">
      {Array.from({ length: count }).map((_, idx) => (
        <Col sm={sm} key={`card_skel_${idx}`} className="mb-4">
          <Card className="h-100 shadow-sm border-0">
            <CardBody className="p-4">
              <div className="d-flex align-items-center mb-3">
                <div className="shimmer-box shimmer-avatar me-3" />
                <div className="flex-grow-1">
                  <div className="shimmer-box shimmer-text" style={{ width: '60%', height: '14px' }} />
                </div>
              </div>
              <div className="mt-3">
                <div className="shimmer-box shimmer-title" style={{ width: '45%', height: '24px' }} />
                <div className="d-flex align-items-center gap-2 mt-2">
                  <div className="shimmer-box shimmer-text" style={{ width: '50%', height: '12px' }} />
                  <div className="shimmer-box shimmer-text" style={{ width: '25%', height: '18px', borderRadius: '12px' }} />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

const LoaderCard = ({ message = "Loading data, please wait...", skeleton = true }) => {
  if (skeleton) {
    return <TableSkeletonLoader rows={5} columns={6} />;
  }

  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5 fade-in-content" style={{ minHeight: '220px' }}>
      <div className="spinner-chase mb-3">
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
        <div className="chase-dot" />
      </div>
      <span className="text-muted font-size-13 fw-medium mt-2">{message}</span>
    </div>
  );
};

export default LoaderCard;